import form from './DeviceBasicConfig/DeviceBasicConfigv1.json'
import formV2 from './DeviceBasicConfig/DeviceBasicConfigv2.json'
export enum FormTypes {
    DeviceBasicConfig = 'DeviceBasicConfig',
    DeviceBasicConfigV2 = 'DeviceBasicConfigV2'
}

export const getMappingOfForms: {
    [key in FormTypes]: {
        currentForm: any
        currentVersion: number
        name: string
    }
} = {
    [FormTypes.DeviceBasicConfig]: {
        currentForm: form,
        currentVersion: 1,
        name: 'Basic Config Form'
    },
    [FormTypes.DeviceBasicConfigV2]: {
        currentForm: formV2,
        currentVersion: 1,
        name: 'Basic Config Form V2'
    }
}
